<template>
  <b-alert class="alert-auth-callback" variant="warning" show>
    <font-awesome-icon
      icon="exclamation-circle"
      size="lg"
      style="color: #824224; padding-right: 8px"
    />
    <div>
      <b style="color: #824224">{{ errorMessage }}</b>
      <p class="m-0 p-0">{{ errorDetail }}</p>
    </div>
  </b-alert>
</template>

<script>
export default {
  props: {
    errorMessage: {
      type: String,
      required: true
    },
    errorDetail: {
      type: String,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
.alert-auth-callback {
  display: flex;
  padding: 12px 20px;
  border-radius: 3.2px;
  margin-bottom: 16px;
}
</style>
